import { render, staticRenderFns } from "./predictSerList.vue?vue&type=template&id=3cec162c&scoped=true&"
import script from "./predictSerList.vue?vue&type=script&lang=js&"
export * from "./predictSerList.vue?vue&type=script&lang=js&"
import style0 from "./predictSerList.vue?vue&type=style&index=0&id=3cec162c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec162c",
  null
  
)

export default component.exports